import { theme } from '~/theme';

const POPUP_HEIGHT: number = 600;
const POPUP_MAX_HEIGHT: string = '70vh';
const POPUP_WIDTH: number = 320;
const TOOLBAR_HEIGHT: number = 34;

export const useSxStyles = () => {
  return {
    root: {
      height: `${POPUP_HEIGHT}px`,
      maxHeight: POPUP_MAX_HEIGHT,
      width: `${POPUP_WIDTH}px`,
      zIndex: 12,
    },
    rootPaper: {
      display: 'flex',
      flexBasis: 'auto',
      flexDirection: 'column',
      flexGrow: 0,
      flexShrink: 1,
      height: `${POPUP_HEIGHT}px`,
      maxHeight: POPUP_MAX_HEIGHT,
      position: 'relative',
      width: `${POPUP_WIDTH}px`,
    },
    appBar: {
      boxSizing: 'border-box',
      display: 'block',
      flexBasis: 'auto',
      flexGrow: 0,
      flexShrink: 0,
      height: `${TOOLBAR_HEIGHT}px`,
      width: `${POPUP_WIDTH}px`,
      zIndex: 0,
      '& .MuiToolbar-root': {
        minHeight: `${TOOLBAR_HEIGHT}px`,
        padding: theme.spacing(0, 1),
      },
    },
    toolbar: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      minHeight: `${TOOLBAR_HEIGHT}px`,
      height: `${TOOLBAR_HEIGHT}px`,
      width: `${POPUP_WIDTH}px`,
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    },
    toolbarIconButton: {
      maxHeight: `${TOOLBAR_HEIGHT - 4}px`,
      maxWidth: `${TOOLBAR_HEIGHT - 4}px`,
      padding: '6px',
    },
    toolbarIcon: {
      fontSize: theme.typography.h6.fontSize,
    },
    toolbarTitle: {
      flexGrow: 1,
      textAlign: 'left',
      fontSize: '14px',
      marginLeft: theme.spacing(),
    },
    content: {
      backgroundColor: theme.palette.background.default,
      boxSizing: 'border-box',
      display: 'block',
      flexBasis: 'auto',
      flexGrow: 1,
      flexShrink: 1,
      overflowY: 'auto',
      width: `${POPUP_WIDTH}px`,
    },
  };
};
